// @flow
import { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'app/api';
import { GET_CAFETERIA_CUSTOMER_ORDERS, convertParams, convertResult } from 'app/common/api/requests/cafeteria/customer/orders';

import type { Params, OrderRequest } from '../../dataTypes/orderRequests/OrderRequest.types';


export default function useOrderRequests(params: Params): [
  Array<OrderRequest>,
  boolean,
  () => void | Promise<void>
] {
  const { t } = useTranslation('cafeteria');

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const request = useCallback(async () => {
    setLoading(true);
    const res = await api.request(GET_CAFETERIA_CUSTOMER_ORDERS, {
      error: t('order_request_sales_put_on_food_order_requests_fetch_error', 'Не удалось получить заявки'),
      params,
      convertions: {
        convertParams,
        convertResult,
      },
    });

    if (res) {
      setItems(res);
    }
    setLoading(false);
  }, [params, t]);

  useEffect(() => {
    request();
  }, [request]);

  return [items, loading, request];
}
